import { NgModule } from '@angular/core';
import {UserClubModalComponent} from './user-club-modal/user-club-modal.component';
import {TelerecourspnrSharedModule, UserService} from '../shared';
import {UserClubComponent} from './user-club.component';
import {UserClubUnsubscribeComponent} from './user-club-unsubscribe/user-club-unsubscribe.component';
import {RouterModule} from '@angular/router';
import {UserClubRoute} from './user-club.route';

@NgModule({
    imports: [
        TelerecourspnrSharedModule,
        RouterModule.forRoot([UserClubRoute], { useHash: true }),
    ],
    declarations: [
        UserClubComponent,
        UserClubModalComponent,
        UserClubUnsubscribeComponent
    ],
    entryComponents: [UserClubModalComponent],
    exports: [
        UserClubComponent
    ],
    providers: [
        UserService,
    ]
})
export class TelerecourspnrUserClubModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/user-club/user-club.module.ts